'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _modifiers = require('../../../modifiers');

var _modifiers2 = _interopRequireDefault(_modifiers);

var _element = require('../../element');

var _element2 = _interopRequireDefault(_element);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ButtonGroup = function ButtonGroup(_ref) {
  var children = _ref.children,
      className = _ref.className,
      hasAddons = _ref.hasAddons,
      position = _ref.position,
      renderAs = _ref.renderAs,
      props = _objectWithoutProperties(_ref, ['children', 'className', 'hasAddons', 'position', 'renderAs']);

  return _react2.default.createElement(
    _element2.default,
    _extends({}, props, {
      renderAs: renderAs,
      className: (0, _classnames3.default)('buttons', className, _defineProperty({
        'has-addons': hasAddons
      }, 'is-' + [position], position))
    }),
    children
  );
};

ButtonGroup.propTypes = _extends({}, _modifiers2.default.propTypes, {
  className: _propTypes2.default.string,
  hasAddons: _propTypes2.default.bool,
  position: _propTypes2.default.oneOf(['centered', 'right']),
  renderAs: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
});

ButtonGroup.defaultProps = _extends({}, _modifiers2.default.defaultProps, {
  className: undefined,
  hasAddons: undefined,
  position: undefined,
  renderAs: 'div'
});

exports.default = ButtonGroup;
//# sourceMappingURL=button-group.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bulma-components/lib/components/button/components/button-group.js
// module id = 1265
// module chunks = 0